import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.workload')
  .factory('$workload', workloadArrayFactory);

function workloadArrayFactory($bringozFactory: $bringozFactory,
                              WorkloadApi: BringozApi,
                              Workload_DS: DataStoreConfig) {

  function $workload() {
    return $bringozFactory(null, WorkloadApi, Workload_DS);
  }

  return $workload;
}

